// Topic registry of the in-console user manual (route /help/$topic). Order = order in the manual's contents.
import type { HelpLocale, HelpTopic, HelpTopicPair } from "./types";
import gettingStarted from "./topics/getting-started";
import overview from "./topics/overview";
import users from "./topics/users";
import userDetail from "./topics/user-detail";
import signInMethod from "./topics/sign-in-method";
import groups from "./topics/groups";
import roles from "./topics/roles";
import customFields from "./topics/custom-fields";
import oauthClients from "./topics/oauth-clients";
import clientDetail from "./topics/client-detail";
import auditLogs from "./topics/audit-logs";
import userTypes from "./topics/user-types";
import branding from "./topics/branding";
import data from "./topics/data";
import logRetention from "./topics/log-retention";

export const HELP_TOPICS: HelpTopicPair[] = [
  gettingStarted,
  overview,
  users,
  userDetail,
  signInMethod,
  groups,
  roles,
  customFields,
  oauthClients,
  clientDetail,
  auditLogs,
  userTypes,
  branding,
  data,
  logRetention,
];

export const DEFAULT_TOPIC = "getting-started";

export function helpTopic(id: string, locale: HelpLocale): HelpTopic | undefined {
  return HELP_TOPICS.find((t) => t.en.id === id)?.[locale];
}

/** The manual page for a console route (the header help icon). */
export function topicForPath(pathname: string): string {
  const rules: [RegExp, string][] = [
    [/^\/users\/[^/]+/, "user-detail"],
    [/^\/users$/, "users"],
    [/^\/sign-in-method/, "sign-in-method"],
    [/^\/groups/, "groups"],
    [/^\/roles/, "roles"],
    [/^\/custom-fields/, "custom-fields"],
    [/^\/oauth-clients\/[^/]+/, "client-detail"],
    [/^\/oauth-clients$/, "oauth-clients"],
    [/^\/audit-logs/, "audit-logs"],
    [/^\/settings\/user-types/, "user-types"],
    [/^\/settings\/branding/, "branding"],
    [/^\/settings\/data/, "data"],
    [/^\/settings\/log-retention/, "log-retention"],
    [/^\/$/, "overview"],
  ];
  return rules.find(([re]) => re.test(pathname))?.[1] ?? DEFAULT_TOPIC;
}
